"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _vuex = require("vuex");
var _validate = require("@/utils/validate");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  components: {
    Card: _components.Card
  },
  data: function data() {
    return {
      idClient: null,
      listDocuments: []
    };
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idClient = id;
      this.getDocuments();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDocumentsSevices', 'deleteDocumentClient', 'uploadToS3'])), {}, {
    valiDocument: function valiDocument(item) {
      if ((0, _validate.validURL)(item.Name)) return true;
      return false;
    },
    saveDocuments: function () {
      var _saveDocuments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              e.preventDefault();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function saveDocuments(_x) {
        return _saveDocuments.apply(this, arguments);
      }
      return saveDocuments;
    }(),
    getDocuments: function () {
      var _getDocuments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchDocumentsSevices(this.idClient);
            case 1:
              data = _context2.v;
              if (data) {
                this.listDocuments = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDocuments() {
        return _getDocuments.apply(this, arguments);
      }
      return getDocuments;
    }(),
    uploadFiles: function () {
      var _uploadFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file, type) {
        var self;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              self = this;
              return _context4.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resolve, reject) {
                  var data, resp;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        data = {
                          image: file,
                          typeFile: type || ''
                        };
                        _context3.n = 1;
                        return self.uploadToS3(data);
                      case 1:
                        resp = _context3.v;
                        if (resp) resolve(resp);else reject();
                      case 2:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x4, _x5) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee4, this);
      }));
      function uploadFiles(_x2, _x3) {
        return _uploadFiles.apply(this, arguments);
      }
      return uploadFiles;
    }(),
    addNewDocument: function addNewDocument() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalFormDocumentClient,
        hasModalCard: true,
        customClass: 'modal-form-new-business-unit-component',
        trapFocus: true,
        canCancel: ['escape', 'outside'],
        props: {
          idClient: this.idClient,
          reload: this.getDocuments,
          entity: 'DigitalAsset'
        }
      });
    },
    confirmDelete: function confirmDelete(item) {
      var _this = this;
      this.$buefy.dialog.confirm({
        title: 'Excluir documento',
        message: "<a>Deseja excluir o documento <b>".concat(item.Name, "</b>?</a>"),
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          return _this.deleteDocument(item);
        }
      });
    },
    deleteDocument: function () {
      var _deleteDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(document) {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.deleteDocumentClient(document.DocumentId);
            case 1:
              data = _context5.v;
              if (data) {
                this.getDocuments();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function deleteDocument(_x6) {
        return _deleteDocument.apply(this, arguments);
      }
      return deleteDocument;
    }(),
    openLink: function openLink(item) {
      window.open(item.Link);
    }
  })
};